/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IManageDocumentsScope extends ng.IScope {
        manageSection: Wars.Domain.Model.ManageSection;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        isConfigureMode: boolean;
        isEditMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        manageCanUploadDocumentSecurityMatrix: () => void;
        manageCanSelectDocumentSecurityMatrix: () => void;
        manageCanSelectSecureDocumentSecurityMatrix: () => void;
        manageCanEditIsSecureDocumentSecurityMatrix: () => void;
        saveChanges: any;
        documentChecked: any;
        sectionDocuments: Wars.Domain.Model.Dtos.DocumentDto[];
        progress: any;
        fileName: string;
        canAddDocuments: boolean;
        allowEditOfSecuredDocumentColumn: boolean;
        editIsSecureDocument(document: Wars.Domain.Model.Dtos.DocumentDto): void;
        canSelectDocuments: boolean;
        canSelectSecureDocuments: boolean;
        acceptsText: string;
        uploadFiles: any;
        documentUpdated(model: models.FileUploadModel): void;
        documentModel: any;
        sortBy: string;
        sortGridBy: (column: string) => void;
    }

    export class ManageDocuments implements IDirective {
        public link($scope: IManageDocumentsScope,
            element: JQuery,
            attrs: ng.IAttributes) {
            $scope.documentModel = {
                refresh: false,
                documentId: undefined
            };
            $scope.sortBy = '-lastUpdateDate';
        }

        public templateUrl = './app/views/directives/manageForm/manageDocuments.html';
        public controller = [
            '$scope', 'formService', 'growl', '$q', 'securityMatrixService', 'manageDocumentSelectionService', 'Upload',
            'processService', "systemLevelService", "processDocumentService", "fileUploadDownloadService", ManageDocumentsController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            manageSection: "=",
            process: "=",
            processConfiguration: "=",
            processConfigurationId: "="
        };
    }

    export class ManageDocumentsController {
        public selectedUser: any;
        selectedReviewUserId: string;
        private processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        private processClaims: Wars.Domain.Model.ClaimDefinition[];

        constructor(private scope: IManageDocumentsScope,
            private formService: services.FormService,
            private growl: angular.growl.IGrowlService,
            private $q: angular.IQService,
            private securityMatrixService: services.SecurityMatrixService,
            private manageDocumentSelectionService: services.ManageDocumentSelectionService,
            private upload: any,
            private processService: services.ProcessService,
            private systemLevelService: services.SystemLevelService,
            private processDocumentService: services.ProcessDocumentService,
            private fileUploadDownloadService: services.FileUploadDownloadService)
        {
            scope.manageCanUploadDocumentSecurityMatrix = () => this.manageCanUploadDocumentSecurityMatrix();
            scope.manageCanSelectDocumentSecurityMatrix = () => this.manageCanSelectDocumentSecurityMatrix();
            scope.manageCanSelectSecureDocumentSecurityMatrix = () => this.manageCanSelectSecureDocumentSecurityMatrix();
            scope.manageCanEditIsSecureDocumentSecurityMatrix = () => this.manageCanEditIsSecureDocumentSecurityMatrix();
            scope.saveChanges = () => this.saveChanges();
            scope.documentChecked = (id) => this.documentChecked(id);
            scope.uploadFiles = (files) => this.uploadFiles(files);
            scope.documentUpdated = (model: models.FileUploadModel) => this.documentUpdated(model);
            scope.editIsSecureDocument = (document: Wars.Domain.Model.Dtos.DocumentDto) => this.editIsSecureDocument(document);
            scope.acceptsText = ".gif,.jpeg,.jpg,.jpe,.tiff,.tif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.dwg";
            scope.sortGridBy = (column: string) : void => {
                if (this.scope.sortBy === column) {
                    this.scope.sortBy = "-" + column;
                } else {
                    this.scope.sortBy = column;
                }
            }
            this.setupData();

            scope.$watch("process.documentSections", () => {
                this.setDocumentsForGrid();
            });
        }

        private setupData() {
            this.setDocumentsForGrid();
        }

        private setDocumentsForGrid(): void {
            if (this.scope.process && this.scope.process.documents) {
                this.scope.sectionDocuments = [];
                if (this.scope.process.documentSections && this.scope.process.documentSections[this.scope.manageSection.uniqueIdentifier]) {
                    let docSection: Wars.Domain.Model.Dtos.ManageDocumentSectionDto = this.scope.process.documentSections[this.scope.manageSection.uniqueIdentifier];
                    this.scope.canAddDocuments = docSection.canAddDocuments;
                    this.scope.allowEditOfSecuredDocumentColumn = docSection.allowEditOfSecuredDocumentColumn;
                    this.scope.canSelectDocuments = docSection.canSelectDocuments;
                    this.scope.canSelectSecureDocuments = docSection.canSelectSecureDocuments;

                    for (var i = 0; i < this.scope.process.documents.length; i++) {
                        var currentDoc = this.scope.process.documents[i];
                        if (docSection.documentIds.indexOf(currentDoc.id) !== -1) {
                            this.scope.sectionDocuments.push(currentDoc);

                            var result = Enumerable
                                .from(docSection.documentSelections)
                                .singleOrDefault(doc => currentDoc.id === doc.id);

                            if (result) {
                                (<any>currentDoc).isSelected = result.isSelected;
                                (<any>currentDoc).selectionOrder = result.selectionOrder;
                            }
                        }
                    }
                }
            }
        }

        private manageCanUploadDocumentSecurityMatrix() : void {
            if (!this.scope.manageSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix) {
                this.scope.manageSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix =
                    this.securityMatrixService.createSecurityMatrix(false, true);
            }
            this.securityMatrixService.openSecurityMatrixModal(
                this.scope.manageSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix,
                this.scope.processConfigurationId);
        }

        private manageCanSelectDocumentSecurityMatrix(): void {
            if (!this.scope.manageSection.manageDocumentsConfiguration.canSelectDocumentsSecurityMatrix) {
                this.scope.manageSection.manageDocumentsConfiguration.canSelectDocumentsSecurityMatrix =
                    this.securityMatrixService.createSecurityMatrix(false, true);
            }
            this.securityMatrixService.openSecurityMatrixModal(
                this.scope.manageSection.manageDocumentsConfiguration.canSelectDocumentsSecurityMatrix,
                this.scope.processConfigurationId);
        }

        private manageCanSelectSecureDocumentSecurityMatrix(): void {
            if (!this.scope.manageSection.manageDocumentsConfiguration.canSelectSecureDocumentsSecurityMatrix) {
                this.scope.manageSection.manageDocumentsConfiguration.canSelectSecureDocumentsSecurityMatrix =
                    this.securityMatrixService.createSecurityMatrix(false, true);
            }
            this.securityMatrixService.openSecurityMatrixModal(
                this.scope.manageSection.manageDocumentsConfiguration.canSelectSecureDocumentsSecurityMatrix,
                this.scope.processConfigurationId);
        }

        private manageCanEditIsSecureDocumentSecurityMatrix(): void {
            if (!this.scope.manageSection.manageDocumentsConfiguration.canEditIsSecureValueSecurityMatrix) {
                this.scope.manageSection.manageDocumentsConfiguration.canEditIsSecureValueSecurityMatrix =
                    this.securityMatrixService.createSecurityMatrix(false, false);
            }
            this.securityMatrixService.openSecurityMatrixModal(
                this.scope.manageSection.manageDocumentsConfiguration.canEditIsSecureValueSecurityMatrix,
                this.scope.processConfigurationId);
        }

        private saveChanges() {
            this.formService.saveAllChanges();
        }

        private editIsSecureDocument(document: Wars.Domain.Model.Dtos.DocumentDto): void {
            var beforeChange = !document.isSecured;
            this.fileUploadDownloadService.editIsSecure(document.id, this.scope.manageSection.manageDocumentsConfiguration.uniqueIdentifier, document.isSecured).then(
                () => {},
                () => {
                    // Failed set checkbox back to pre-clicked value
                    document.isSecured = beforeChange;
                });

        }

        private documentUpdated(model: models.FileUploadModel): void {
            this.setDocumentsForGrid();
            this.scope.documentModel.documentId = undefined;
            this.scope.documentModel.refresh = true;
        }

        private documentChecked(document: any) {
            this.manageDocumentSelectionService.updateDocumentSelection(
                this.scope.process.id,
                this.scope.manageSection.uniqueIdentifier,
                document.id,
                document.isSelected).then((documentSelections: Wars.Domain.Model.Execution.DocumentSelection[]) =>
                {
                    for (var i = 0; i < this.scope.sectionDocuments.length; i++) {
                        var match = Enumerable.from(documentSelections).singleOrDefault(document => document.id === this.scope.sectionDocuments[i].id);
                        if (match) {
                            (<any>this.scope.sectionDocuments[i]).isSelected = match.isSelected;
                            (<any>this.scope.sectionDocuments[i]).selectionOrder = match.selectionOrder;
                        } else {
                            (<any>this.scope.sectionDocuments[i]).isSelected = false;
                            (<any>this.scope.sectionDocuments[i]).selectionOrder = undefined;
                        }
                    }
                });
        }

        private loadDocumentTable() {
            this.processService.getProcessDto(this.scope.process.id)
                .then(r => {
                    this.scope.process = r;
                    this.setupData();
                });
        }

        private uploadFiles(files) {
            var self = this;
            this.scope.fileName = files[0].name;

            if (files && files.length) {
                this.upload.upload({
                    url: './api/document/process/' + this.scope.process.id,
                    data: {
                        files: files
                    }
                })
                    .then(response => {
                        this.loadDocumentTable();
                    },
                    response => {
                        if (response.status > 0) {
                            this.growl.error(response.status + ': ' + response.data);
                        } else {
                            this.loadDocumentTable();

                        }
                    },
                    evt => {
                        this.scope.progress = Math.min(100, parseInt((<any>(100.0 * evt.loaded / evt.total))));
                    });
            }

        }
    }
}
warsApp.registerDirective('ManageDocuments', []);